// React Thirty Party Library
import { useDispatch } from "react-redux";

// Constants Library
import { TEMPLATE, ROOT_CONSTANT } from "../../../../../../constants";

// Components Library
import {
  ButtonModal,
  BtnSubmit,
  TablePagination,
} from "../../../../../../components";

// Styles Library
import classes from "../../../../../../pages/index.module.css";

const SearchFile = (props) => {
    const {
    //     setIsModalOpen,
      pageSize,
      setPageSize,
      current,
      setCurrent,
      tabKey,
      handlePaginatedDataChange,
      filteredDataCount,
      data,
    //     user,
    //     selectedRow,
    //     selectedRowKeys,
    //     messageApi,
    //     setIsClicked
    } = props;

    return (
        <>
          <div className={classes.headerPage}>
            <div className={{ display: "flex", justifyContent: "end" }}>
                <TablePagination
                    tabKey={tabKey}
                    data={data}
                    filteredDataCount={filteredDataCount}
                    onPaginatedDataChange={handlePaginatedDataChange}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    current={current}
                    setCurrent={setCurrent}
                />
            </div>
          </div>
        </>
    );
}

export default SearchFile;